/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { UnfiledContainerAssociationPaging, UnfiledContainerEntry } from '../model';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class UnfiledContainersApi extends BaseApi {
    createUnfiledContainerChildren(unfiledContainerId, nodeBodyCreate, opts) {
        throwIfNotDefined(unfiledContainerId, 'unfiledContainerId');
        throwIfNotDefined(nodeBodyCreate, 'nodeBodyCreate');
        const pathParams = {
            unfiledContainerId
        };
        const queryParams = {
            autoRename: opts === null || opts === void 0 ? void 0 : opts.autoRename,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        const contentTypes = ['application/json', 'multipart/form-data'];
        return this.post({
            path: '/unfiled-containers/{unfiledContainerId}/children',
            pathParams,
            queryParams,
            contentTypes,
            bodyParam: nodeBodyCreate,
            returnType: UnfiledContainerAssociationPaging
        });
    }
    getUnfiledContainer(unfiledContainerId, opts) {
        throwIfNotDefined(unfiledContainerId, 'unfiledContainerId');
        const pathParams = {
            unfiledContainerId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/unfiled-containers/{unfiledContainerId}',
            pathParams,
            queryParams,
            returnType: UnfiledContainerEntry
        });
    }
    listUnfiledContainerChildren(unfiledContainerId, opts) {
        throwIfNotDefined(unfiledContainerId, 'unfiledContainerId');
        const pathParams = {
            unfiledContainerId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            where: opts === null || opts === void 0 ? void 0 : opts.where,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/unfiled-containers/{unfiledContainerId}/children',
            pathParams,
            queryParams,
            returnType: UnfiledContainerAssociationPaging
        });
    }
    updateUnfiledContainer(unfiledContainerId, unfiledContainerBodyUpdate, opts) {
        throwIfNotDefined(unfiledContainerId, 'unfiledContainerId');
        throwIfNotDefined(unfiledContainerBodyUpdate, 'unfiledContainerBodyUpdate');
        const pathParams = {
            unfiledContainerId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/unfiled-containers/{unfiledContainerId}',
            pathParams,
            queryParams,
            bodyParam: unfiledContainerBodyUpdate,
            returnType: UnfiledContainerEntry
        });
    }
}
